<script setup lang="ts">
  import { onUnmounted, ref, watch } from 'vue';
  import SearchIcon from '@/shared/assets/icons/SearchIcon.svg';
  import { IconImage } from '@/shared/ui';

  const props = defineProps({
    initialSearchTerm: { type: String, default: '' },
    branch: String,
    noContainer: { type: Boolean, default: false },
  });

  const searchTerm = ref(props.initialSearchTerm);
  const emit = defineEmits(['search']);

  let debounceTimeout: ReturnType<typeof setTimeout> | null = null;

  watch(searchTerm, (newVal: string) => {
    if (debounceTimeout) clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {
      emit('search', newVal);
    }, 300);
  });

  watch(
    () => props.initialSearchTerm,
    (newVal: string) => {
      searchTerm.value = newVal;
    }
  );

  onUnmounted(() => {
    if (debounceTimeout) clearTimeout(debounceTimeout);
  });
</script>
<template>
  <div
    :class="['w-full', props.noContainer ? 'h-full' : 'bg-white-01 border border-gray-02 rounded-lg h-[42px]']"
  >
    <div class="relative h-full">
      <span class="text-gray-02 absolute inset-y-0 left-0 flex items-center pl-3">
        <IconImage
          :src="SearchIcon"
          alt="Search"
          class="min-h-5 min-w-5"
        />
      </span>
      <input
        v-model="searchTerm"
        type="text"
        placeholder="Buscar"
        :class="[
          'pl-10 pr-4 py-2 w-full h-full text-gray-03 focus:outline-none',
          props.noContainer ? 'bg-transparent rounded-none' : 'rounded-md bg-white-01',
        ]"
      >
    </div>
  </div>
</template>
